module.exports = __webpack_public_path__ + "img/manage-permission.df383d85.svg";